import { mapGetters, mapActions } from 'vuex'
import { isArray, isEmpty, trim, getByteLen, getKeyOfData, clearTagOfData } from '@/common/js/utils'
// 默认数据
// import weektimeData from '@/data/baidu/weektime_data'
// import cityData from '@/data/baidu/city_province'
// import gategoryData from '@/data/baidu/app_categroy'
// import articleData from '@/data/baidu/article_categroy'
// import themeData from '@/data/baidu/theme_categroy'
// import mediagoryData from '@/data/baidu/media_categroy'
// import tagsData from '@/data/baidu/ad_tag'
// 公共组件
import Mixcheck from '@/components/mixcheck'
import CheckItem from '@/components/mixcheck/check-item'
import RadioItem from '@/components/mixcheck/radio-item'
import Moduler from '@/components/moduler.vue'
import ErrorPop from '@/components/error-pop.vue'
import InputLen from '@/components/input/input-len.vue'
import InputNumberPlus from '@/components/input/input-number-plus'
import AutoComplete from '@/components/autocomplete/autocomplete.vue'

// const DATA = { weektimeData, cityData, gategoryData, articleData, themeData, tagsData, mediagoryData }

export default {
  components: { Mixcheck, CheckItem, RadioItem, Moduler, InputLen, AutoComplete, ErrorPop, InputNumberPlus },
  computed: {
    ...mapGetters('Baidu', [
      'subCurrent',
      'subModules'
    ]),
    media () {
      return parseInt(this.$store.state.Baidu.media)
    }
  },
  methods: {
    ...mapActions('Baidu', [
      'refreshDocTitle'
    ]),
    invalid (rules) {
      const arr = []
      if (!isArray(rules)) throw new Error('rule must be array')
      for (let i = 0; i < rules.length; i++) {
        let param
        let length
        const rule = rules[i]
        const ruleName = rule.name.indexOf('/') > -1 ? this[rule.name.split('/')[0]][rule.name.split('/')[1]] : this[rule.name]
        if (typeof ruleName === 'undefined') continue
        if (typeof ruleName === 'string' && !rule.charset) {
          param = trim(ruleName)
          length = getByteLen(param)
        } else if (isArray(ruleName)) {
          param = ruleName
          length = param.length
        } else if (typeof ruleName === 'string' && rule.charset === 'bc') {
          param = ruleName
          length = String(param).length
        } else if (typeof ruleName === 'number') {
          param = length = ruleName
        }

        // 依赖
        if (rule.relyon) {
          const rely = rule.relyon.indexOf('/') > -1 ? this[rule.relyon.split('/')[0]][rule.relyon.split('/')[1]] : this[rule.relyon]
          if (rely !== rule.relyvalue) continue
        }

        // 必填
        if (rule.require && isEmpty(param)) {
          const msg = `${rule.desc}不能为空`
          this.formErr = true
          arr.push({ feild: rule.desc, msg })
          continue
        }

        // 长度判断
        if (typeof param === 'string' || isArray(param)) {
          if (param && rule.max < length) {
            const msg = `${rule.desc}不能多于${rule.max}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (param && rule.min > length) {
            const msg = `${rule.desc}不能少于${rule.min}个字符`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 大小判断
        if (typeof param === 'number') {
          if (rule.max < length) {
            const msg = `${rule.desc}数值不能大于${rule.max}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
          if (rule.min > length) {
            const msg = `${rule.desc}数值不能小于${rule.min}`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }

        // 正则
        if (rule.pattern) {
          const reg = new RegExp(rule.pattern, 'g')
          if (!reg.test(param)) {
            const msg = `${rule.desc}不是有效的值`
            this.formErr = true
            arr.push({ feild: rule.desc, msg: rule.msg || msg })
            continue
          }
        }
      }
      return arr
    },
    inputTrim (key, val, obj, fixed) {
      if (isEmpty(val)) return val
      val = trim(val)
      if (fixed) {
        val = parseFloat(val) * 100
        val = Math.floor(val) / 100
      } else val = parseInt(val)
      obj[key] = val
    },
    pullKeys (keys, obj) {
      const form = {}
      for (const key in obj) {
        if (keys.includes(key)) {
          form[key] = obj[key]
        }
      }
      return form
    },
    betchValid (form) {
      const { bitch_add_begin, bitch_add_end } = form
      const feild = '批量数量'
      const errRes = []
      if (bitch_add_end - bitch_add_begin <= 0) {
        errRes.push({ feild, msg: '批量结束数必须大于起始数且相差大于1' })
      } else if (bitch_add_end - bitch_add_begin > 10) {
        errRes.push({ feild, msg: '批量相差不能大于10' })
      }
      return errRes
    },
    cannelError () {
      this.errRes = []
    },
    cannel () {
      this.closePageForm()
    },
    closePageForm () {
      this.$Message.info({
        content: '页面将 2 秒后自动关闭',
        duration: 2,
        onClose: () => {
          window.close()
        }
      })
    },
    beforeHandler () {
      window.onbeforeunload = function (event) {
        const msg = '您正在编辑内容，离开数据将丢失，确定要退出本页吗？'
        event.returnValue = msg
        return msg
      }
    },
    toTop () {
      this.$nextTick(() => {
        const contentElem = window.document.querySelector('.ivu-layout-content')
        contentElem.scrollTop = 0
        contentElem.addEventListener('scroll', this.handleScroll)
      })
    },
    toHref (scrollTop) {
      this.$nextTick(() => {
        const contentElem = window.document.querySelector('.ivu-layout-content')
        contentElem.scrollTop = scrollTop
        this.$store.commit('Baidu/setScroll', scrollTop)
      })
    },
    handleScroll (e) {
      this.$store.commit('Baidu/setScroll', e.target.scrollTop)
    },
    // 不限时还原默认值 - 地区组件\时间段组件
    radioChange (key) {
      clearTagOfData(this[key], this)
    },
    watchIncludes () {
      if (isArray(this.includes) && this.includes.length && this.retargetData.length) {
        this.includes.forEach(ret => {
          const item = getKeyOfData(this.retargetData, 'id', ret)
          this.$set(item, 'select', 'include')
        })
      }
    },
    watchexcludes () {
      if (isArray(this.excludes) && this.excludes.length && this.retargetData.length) {
        this.excludes.forEach(ret => {
          const item = getKeyOfData(this.retargetData, 'id', ret)
          this.$set(item, 'select', 'exclude')
        })
      }
    },
    watchSchedule (schedule) {
      const o = {}
      if (isArray(schedule)) {
        this.schedule.forEach((ret, id) => {
          switch (id) {
            case 0:
              o.monday = ret
              break
            case 1:
              o.tuesday = ret
              break
            case 2:
              o.wednesday = ret
              break
            case 3:
              o.thursday = ret
              break
            case 4:
              o.friday = ret
              break
            case 5:
              o.saturday = ret
              break
            case 6:
              o.sunday = ret
              break
          }
        })
      }
      return o
    },
    getAppId (url) {
      if (!url) return url
      const c_url = url.split('/')
      if (c_url && c_url.length) {
        const pop = c_url.pop()
        const regx = /^(id[0-9]+)|(ID[0-9]+)/i
        const app = regx.exec(pop)
        if (app && app.length) return app[0].replace(/(id)|(ID)/g, '')
        return url
      }
    },
    retry () {
      this.data = []
      this.submitToNext()
    },
    jumpToIdea (params, query) {
      this.$store.commit('Baidu/setCurrent', 'idea')
      this.$store.commit('Baidu/changeState', 'unit')
      this.$router.push({
        name: 'idea',
        params,
        query
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.toTop()
      this.refreshDocTitle()
    })
  }
}
